// Toggle sound for mp4 background videos in the video-with-text-overlay section
// Assumes buttons rendered with data-sound-toggle and data-target = section id
(function(){
  function init(){
    document.querySelectorAll('[data-sound-toggle]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        // Prevent parent anchor (CTA mode) from navigating when clicking toggle
        e.stopPropagation();
        e.preventDefault();
        const pressed = btn.getAttribute('aria-pressed') === 'true';
        const newPressed = !pressed;
        btn.setAttribute('aria-pressed', String(newPressed));
        btn.setAttribute('aria-label', newPressed ? 'Mute video' : 'Unmute video');
        // swap icons
        const mutedIcon = btn.querySelector('.icon-muted');
        const unmutedIcon = btn.querySelector('.icon-unmuted');
        if(newPressed){
          // now unmuted
          mutedIcon.classList.add('hidden');
          unmutedIcon.classList.remove('hidden');
        } else {
          mutedIcon.classList.remove('hidden');
          unmutedIcon.classList.add('hidden');
        }
        // Find video elements within same block container (both desktop + mobile copies)
        const container = btn.closest('[data-media-container]') || document;
        const videos = container.querySelectorAll('.background-video video');
        videos.forEach(v => {
          // If unmuting, try to play; browsers require user gesture which this click satisfies.
          v.muted = !newPressed ? true : false;
          if(newPressed){
            // ensure playback continues with sound
            if(v.paused){
              v.play().catch(()=>{});
            }
          }
        });
      });
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
